import StarCount from '../../components/StarCount'

export const FurtherAsides = StarCount
